<template>
  <span :class="['inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold', colorClasses]">
    <i v-if="icon" :class="[icon, 'text-[10px] mr-1']"></i>
    {{ value }}
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  severity: { type: String, default: 'info' },
  value: { type: String, default: '' },
  icon: { type: String, default: '' }
})

const colorMap = {
  success: 'bg-green-100 text-green-800',
  info: 'bg-blue-100 text-blue-800',
  warning: 'bg-amber-100 text-amber-800',
  danger: 'bg-red-100 text-red-800',
  secondary: 'bg-gray-100 text-gray-700',
  contrast: 'bg-gray-800 text-white',
}

const colorClasses = computed(() => colorMap[props.severity] || colorMap.info)
</script>
